import { useMemo } from "react";
import { useDailySalesQuery } from "../../query/adminDailySalesQuery";
import { isSalesToday } from "../../utils/dailySalesUtils";
import { SalesPieChartCard } from "./SalesPieChartCard";
import { useTranslation } from "react-i18next";

interface SalesBreakdownPieChartProps {
  resellerId?: string;
  date: string;
  selectedDateLabel: string;
}

export const SalesBreakdownPieChart = ({
  resellerId,
  date,
  selectedDateLabel,
}: SalesBreakdownPieChartProps) => {
  const { t } = useTranslation();
  const { data: stats, isLoading } = useDailySalesQuery(date, date, resellerId);
  const isToday = isSalesToday(date);

  const chartData = useMemo(() => {
    const dayStats = stats?.[0];
    if (!dayStats?.receiptCountByPaymentMethodType) return [];
    return Object.entries(dayStats.receiptCountByPaymentMethodType)
      .filter(([, count]) => count > 0)
      .map(([type, value]) => ({
        key: type,
        name: t(`paymentMethodType.${type}`, type),
        value,
        label: String(value),
      }));
  }, [stats, t]);

  const emptyMessage = isToday
    ? t("adminDailySales.noDataToday")
    : t("adminDailySales.noDataOnDate", { date: selectedDateLabel });

  return (
    <SalesPieChartCard
      title={t("adminDailySales.paymentMethods")}
      emptyMessage={emptyMessage}
      isLoading={isLoading}
      chartData={chartData}
      showLegend={false}
    />
  );
};
